export const timeSlotsStepWrapperStyles = {
	'.swiper-button-prev, .swiper-button-next': {
		color: 'primary.main',
		transform: 'scale(0.5)',
	},
};

export const getTimeSlotsStepDayTitle = (isStepDisabled: boolean) => {
	const commonStyles = { margin: '8px 0' };

	if (isStepDisabled) {
		return {
			...commonStyles,
			color: 'text.disabled',
		};
	}

	return commonStyles;
};

export const getTimeSlotsStepShowMoreTimesButton = (isStepDisabled: boolean) => ({
	textDecoration: 'underline',
	display: 'block',
	margin: '0 auto',
	marginTop: '16px',

	'& span': {
		color: isStepDisabled ? 'text.disabled' : '',
	},
});

export const timeSlotsStepPreviousAndNextButtonsWrapper = {
	display: 'flex',
	justifyContent: 'space-between',
	marginTop: '16px',
};

export const getTimeSlotsStepBottomTextWrapper = (isStepDisabled: boolean) => {
	const commonStyles = {
		textAlign: 'center',
		marginTop: '24px',
	};

	if (isStepDisabled) {
		return {
			...commonStyles,
			'& *': {
				color: 'text.disabled',
			},
		};
	}

	return commonStyles;
};
